<template lang="pug">
  transition(name="fadein" appear)
    .close
      router-link(:to="{ name:'top' }" @click.native="playSound('se_click_cancel')")
        img(src="@/assets/images/common/button_close.png")
</template>

<script>
import SoundController from '@/assets/js/SoundController';

export default {
  name: 'CloseButton',
  methods: {
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.close {
  position: absolute;
  top: vw(30);
  right: vw(10);
  width: vw(176);
  z-index: 3;
  a {
    display: block;
  }
}
</style>
